import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as o } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const l = o((e, a) => /* @__PURE__ */ s.jsx(
  i,
  {
    ref: a,
    ...e,
    image: (r) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...r,
        children: [
          /* @__PURE__ */ s.jsxs(
            "mask",
            {
              id: "mask0_2974_3612",
              width: 16,
              height: 12,
              x: 0,
              y: 2,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: [
                /* @__PURE__ */ s.jsx(
                  "path",
                  {
                    fill: "currentColor",
                    d: "M14.35 2H1.65C.74 2 0 2.74 0 3.65v8.64c0 .91.74 1.65 1.65 1.65h12.7c.91 0 1.65-.74 1.65-1.65V3.65C16 2.74 15.26 2 14.35 2m.15 10.29c0 .08-.07.15-.15.15H1.65c-.08 0-.15-.07-.15-.15V3.65c0-.08.07-.15.15-.15h12.7c.08 0 .15.07.15.15z"
                  }
                ),
                /* @__PURE__ */ s.jsx(
                  "path",
                  {
                    fill: "currentColor",
                    d: "M6.64 4.53a.751.751 0 1 0-.77 1.29l3.61 2.15L7 9.45V7.98a.749.749 0 1 0-1.5 0v2.79a.75.75 0 0 0 .75.75c.13 0 .27-.04.38-.11l4.69-2.8c.23-.14.37-.38.37-.64a.74.74 0 0 0-.37-.64z"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_3612)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) })
        ]
      }
    )
  }
));
l.displayName = "AgencyVideoIcon";
export {
  l as AgencyVideoIcon,
  l as default
};
//# sourceMappingURL=index.js.map
